import axios from '@/api';

export function getTranslations(competitionId, language) {
    return axios.get(`panel/competitions/${competitionId}/translations/${language}`);
}

export function updateTranslations(competitionId, language, payload) {
    return axios.put(`panel/competitions/${competitionId}/translations/${language}`, payload);
}

export function updateLanguageToggle(competitionId, payload) {
    return axios.put(`panel/competitions/${competitionId}/settings`, payload);
}
